"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OidcTokenStorage = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _constants = require("../constants");
var _OidcAccessToken = require("../tokens/OidcAccessToken");
var _OidcIdToken = require("../tokens/OidcIdToken");
var _singleton = require("../utils/singleton");
var _SessionValue = require("./SessionValue");
var _class;
let OidcTokenStorage = exports.OidcTokenStorage = (0, _singleton.singleton)(_class = class OidcTokenStorage {
  constructor() {
    (0, _defineProperty2.default)(this, "authorizationCode", new _SessionValue.SessionValue(_constants.AUTHORIZATION_CODE_STORAGE_KEY));
    (0, _defineProperty2.default)(this, "accessToken", new _SessionValue.SessionValue(_constants.USER_TOKEN_STORAGE_KEY));
    (0, _defineProperty2.default)(this, "idToken", new _SessionValue.SessionValue(_constants.ID_TOKEN_STORAGE_KEY));
    (0, _defineProperty2.default)(this, "redirectUrl", new _SessionValue.SessionValue(_constants.AUTH_REDIRECT_URL_STORAGE_KEY));
    (0, _defineProperty2.default)(this, "redirectUri", new _SessionValue.SessionValue(_constants.AUTH_REDIRECT_URI_STORAGE_KEY));
    (0, _defineProperty2.default)(this, "codeVerifier", new _SessionValue.SessionValue(_constants.CODE_VERIFIER_STORAGE_KEY));
    (0, _defineProperty2.default)(this, "state", new _SessionValue.SessionValue(_constants.AUTH_STATE_STORAGE_KEY));
    (0, _defineProperty2.default)(this, "nonce", new _SessionValue.SessionValue(_constants.NONCE_STORAGE_KEY));
    (0, _defineProperty2.default)(this, "getAccessToken", () => {
      const token = this.accessToken.get();
      if (token !== null) {
        return new _OidcAccessToken.OidcAccessToken(token.Token);
      }
      return null;
    });
    (0, _defineProperty2.default)(this, "setAccessToken", tokenData => {
      this.accessToken.set(tokenData);
      return this;
    });
    (0, _defineProperty2.default)(this, "getIdToken", () => {
      const token = this.idToken.get();
      if (token !== null) {
        return new _OidcIdToken.OidcIdToken(token);
      }
      return null;
    });
    (0, _defineProperty2.default)(this, "setIdToken", oidcIdToken => {
      this.idToken.set(oidcIdToken.toString());
      return this;
    });
  }
}) || _class;
